<script lang="ts">
import { defineComponent } from '@mimir/web/compat/vueCompat';
import { VBtn, VIcon } from 'vuetify/lib';

export default defineComponent({
  name: 'CreateButton',
  components: {
    VBtn,
    VIcon,
  },
  props: {
    content: {
      type: String,
    },
    icon: {
      type: String,
      default: 'add',
    },
    small: {
      type: Boolean,
    },
    noIcon: {
      type: Boolean,
    },
  },
});
</script>

<template>
  <VBtn
    class="pa-0 create-btn"
    v-bind="$attrs"
    color="transparent"
    :small="small"
    v-on="$listeners"
  >
    <span class="content mr-1" v-text="content" />
    <VIcon v-if="!noIcon" :small="small">{{ icon }}</VIcon>
  </VBtn>
</template>

<style lang="stylus">
.create-btn
  box-shadow: none !important
  height: 32px !important
  // Battling CSS specificity rules here from Vuetify.
  &.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined)
    background: transparent !important
    .v-btn__content
      color: grey !important
  .v-btn__content
    font-size: 13px
    color: var(--v-primary-base)
    text-transform: none
    letter-spacing: 0
    padding: 0 8px
</style>
